import { FC } from 'react';
import { LoadingSpinner } from '@medtronic/pecc-react-component-library-js';
import { IconButton } from '@mui/material';
import { useLazyGetDatasetConnectionRolesQuery } from '~/api/v2/hooks';
import { Tooltip } from '~/components';
import { InstructionsIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';

interface DatasetConnectionIconProps {
  projectId: number;
  datasetId: number;
}

const DatasetConnectionIcon: FC<DatasetConnectionIconProps> = ({ projectId, datasetId }) => {
  const dispatch = useAppDispatch();
  const [getDatasetConnectionRoles, { isFetching }] = useLazyGetDatasetConnectionRolesQuery();

  const handleClick = async () => {
    const roles = await getDatasetConnectionRoles({ projectId, datasetId }).unwrap();

    dispatch(
      openModal({
        type: ModalTypesEnum.DATASET_CONNECTION_INSTRUCTIONS,
        payload: {
          roleArn: roles.role_arn,
          bucketName: roles.bucket_name,
          bucketFolder: roles.bucket_folder,
        },
      }),
    );
  };

  return (
    <Tooltip title="Connection Instructions" disableInteractive>
      <IconButton size="small" onClick={handleClick} disabled={isFetching} sx={{ p: 0.25 }}>
        {isFetching ? <LoadingSpinner spinnerSize="xxs" /> : <InstructionsIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default DatasetConnectionIcon;
